import script from "./table-nav-menu-mobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./table-nav-menu-mobile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__